/**
 * Channel-aware copy for NFC card activation (Shopify vs in-person).
 * UI-only — does not affect activation logic.
 */
export function getActivationCopy({
  channel,
  isLoggedIn = false,
  isActivating = false,
  isChecking = false
} = {}) {
  const isInPerson =
    channel === 'inPerson' ||
    channel === 'in_person' ||
    channel === 'in-person';

  if (isChecking) {
    return {
      title: isInPerson ? 'Welcome to Velox' : 'Your card is ready',
      subtitle: 'One moment.',
      cta: 'Please wait'
    };
  }

  if (isActivating) {
    return {
      title: isInPerson ? 'Welcome to Velox' : 'Your card is ready',
      subtitle: isInPerson ? 'Setting up your profile.' : 'Linking your card.',
      cta: isInPerson ? 'Activating…' : 'Linking…'
    };
  }

  const title = isInPerson ? 'Welcome to Velox' : 'Your card is ready';
  const subtitle = isInPerson
    ? 'Create your profile and connect this card.'
    : 'Link it to your account.';

  const cta = isLoggedIn
    ? (isInPerson ? 'Activate card' : 'Link to my account')
    : 'Continue';

  return { title, subtitle, cta };
}

export function getManualActivationCopy() {
  return {
    title: 'Link your card',
    subtitle: 'Enter the card ID from your order email.',
    cta: 'Link card',
    ctaLoading: 'Linking…',
    autoTitle: 'Linking your card',
    autoSubtitle: 'One moment.'
  };
}
